import { _$api } from '/home/docker/node_modules/nuxt-api-party/dist/runtime/composables/$api'
import { _useApiData } from '/home/docker/node_modules/nuxt-api-party/dist/runtime/composables/useApiData'
export const $apiServer = (...args) => _$api('apiServer', ...args)
export const useApiServerData = (...args) => _useApiData('apiServer', ...args)
export const $authServer = (...args) => _$api('authServer', ...args)
export const useAuthServerData = (...args) => _useApiData('authServer', ...args)
export const $bflPGServer = (...args) => _$api('bflPGServer', ...args)
export const useBflPGServerData = (...args) => _useApiData('bflPGServer', ...args)
export const $b2bServer = (...args) => _$api('b2bServer', ...args)
export const useB2bServerData = (...args) => _useApiData('b2bServer', ...args)
export const $giftCardServer = (...args) => _$api('giftCardServer', ...args)
export const useGiftCardServerData = (...args) => _useApiData('giftCardServer', ...args)
export const $rewardServer = (...args) => _$api('rewardServer', ...args)
export const useRewardServerData = (...args) => _useApiData('rewardServer', ...args)
export const $finServer = (...args) => _$api('finServer', ...args)
export const useFinServerData = (...args) => _useApiData('finServer', ...args)
